import { render, staticRenderFns } from "./PointsInfo.vue?vue&type=template&id=a7752dec&scoped=true&"
import script from "./PointsInfo.vue?vue&type=script&lang=js&"
export * from "./PointsInfo.vue?vue&type=script&lang=js&"
import style0 from "./PointsInfo.vue?vue&type=style&index=0&id=a7752dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7752dec",
  null
  
)

export default component.exports